import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=e2635116&scoped=true"
import script from "./EmployeeSearch.vue?vue&type=script&lang=ts"
export * from "./EmployeeSearch.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSearch.vue?vue&type=style&index=0&id=e2635116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2635116",
  null
  
)

export default component.exports